import { useEffect, useState } from "react";
import { fetchDeployedRevision } from "../lib/version.js";

// Fetches the app + notifier deployed revisions once per mount, when `enabled`
// is true (i.e. a debug user opens the account modal — the fetch is
// deliberately lazy so normal users never hit the notifier proxy; the modal
// remounts each open, so this refreshes then). Returns:
//   null                 — not yet fetched (render as "loading")
//   { app, notifier }    — the graceful shape from fetchDeployedRevision
// Never throws; a failed request degrades inside fetchDeployedRevision.
export function useDeployedRevision(enabled) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!enabled) return undefined;
    let cancelled = false;
    fetchDeployedRevision().then((d) => {
      if (!cancelled) setData(d);
    });
    return () => {
      cancelled = true;
    };
  }, [enabled]);
  return data;
}
